// extracted by mini-css-extract-plugin
module.exports = {"sortable-ghost":"DateTimeAgo_sortable-ghost__2KNRR","DateTimeAgo":"DateTimeAgo_DateTimeAgo__2z9KG"};